import { useRef } from "react";
import "@/App.css";
import { useScroll, useMotionValueEvent } from "framer-motion";
import { scrollStore } from "@/lib/scrollStore";
import Navbar from "@/components/Navbar";
import DebugPanel from "@/components/DebugPanel";
import { useIOS3DFix } from "@/hooks/useIOS3DFix";
import { ProductStage } from "@/three/ProductStage";
import Hero from "@/sections/Hero";
import Experience from "@/sections/Experience";
import { Procedure, Fda, Drugs, Benefits, Industries } from "@/sections/Sections";
import { Chile, Partners } from "@/sections/ChilePartners";
import Faq from "@/sections/Faq";
import { FinalCta, Footer } from "@/sections/Closing";

function App() {
    useIOS3DFix();
    const heroRef = useRef(null);
    const expRef = useRef(null);
    const { scrollYProgress: heroP } = useScroll({ target: heroRef, offset: ["start start", "end start"] });
    const { scrollYProgress: expP } = useScroll({ target: expRef, offset: ["start start", "end end"] });

    useMotionValueEvent(heroP, "change", (v) => {
        scrollStore.hero = v;
    });
    useMotionValueEvent(expP, "change", (v) => {
        scrollStore.exp = v;
    });

    return (
        <div className="relative bg-white text-[#0A192F] antialiased">
            <Navbar />
            <DebugPanel />
            <ProductStage />
            <main className="relative z-10">
                <Hero ref={heroRef} />
                <Experience ref={expRef} progress={expP} />
                <Procedure />
                <Fda />
                <Drugs />
                <Benefits />
                <Industries />
                <Chile />
                <Partners />
                <Faq />
                <FinalCta />
            </main>
            <Footer />
        </div>
    );
}

export default App;
